import { cn } from "@/core/utils/utils";

interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement | HTMLSpanElement> {
  /**
   * Whether the skeleton should be inline (span) or block (div).
   * Use 'inline' when the skeleton is used within text content.
   * @default 'block'
   */
  variant?: "block" | "inline";
}

const Skeleton = ({
  className,
  variant = "block",
  ...props
}: SkeletonProps) => {
  const Component = variant === "inline" ? "span" : "div";

  return (
    <Component
      className={cn(
        "animate-pulse rounded-md bg-stroke-tertiary",
        variant === "inline" && "inline-block",
        className,
      )}
      {...props}
    />
  );
};

export { Skeleton };
